var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"overlay","appear":""}},[_c('div',{staticClass:"app-overlay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }